// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navBarComponent {
  display: flex;
  padding: 0 2rem;
  width: 100%;
  height: 70px;
  justify-content: space-between;
  background-color: white;
  border-bottom: 1px solid #e8e9e9;
}
.navBarComponent .logoContainer {
  flex: 1 1;
  display: flex;
  align-items: center;
}
.navBarComponent .divider {
  position: relative;
  margin: 0 2rem;
  height: 32px;
  width: 1px;
  border-radius: 0.5px;
  background: #000000;
  opacity: 0.1;
}
.navBarComponent .businessSelectLogoContainer {
  display: inline-block;
  position: relative;
  margin-left: 10px;
  bottom: 3px;
}
.navBarComponent .businessSelectButton .buttonText {
  color: #075453;
}
.navBarComponent .businessSelectButton:hover .buttonText {
  color: #097674;
}
.navBarComponent .flexedRightContainer {
  display: flex;
  align-items: center;
}
.navBarComponent .profileImageContainer {
  position: relative;
  display: flex;
  margin-left: 20px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.navBarComponent .profileImageContainer strong {
  color: white;
  font-size: 12px;
}
.navBarComponent .questionMarkContainer {
  position: relative;
  margin-left: 20px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  text-align: center;
  cursor: pointer;
}
.navBarComponent .shopsolPaymentButtonContainer {
  position: relative;
  margin-left: 20px;
  width: 111px;
  height: 36px;
  color: rgb(0, 0, 0);
  text-align: center !important;
  font-size: 14px;
  padding-top: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: #333333;
  border-radius: 50px;
  border: 2px solid #333333;
  cursor: pointer;
}
.navBarComponent .shopsolPaymentButtonText {
  position: relative;
  top: 1.5px;
  cursor: pointer;
}
.navBarComponent .daysLeftContainer {
  position: relative;
  font-family: "Noto Sans KR";
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: right;
  color: #bd1823;
}

.navBarMenuItem {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: #333333;
  padding: 10px 0;
}
.navBarMenuItem :hover {
  background-color: #ddd;
}

.navBarMenuItem:hover {
  background-color: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./src/components/navBar/NavBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;AACJ;AACI;EACI,SAAA;EACA,aAAA;EACA,mBAAA;AACR;AAGI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAFR;AAMQ;EACI,cAAA;AAJZ;AAQQ;EACI,cAAA;AANZ;AAUI;EACI,aAAA;EACA,mBAAA;AARR;AAWI;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AATR;AAWQ;EACI,YAAA;EACA,eAAA;AATZ;AAaI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAXR;AAcI;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAZR;AAeI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AAbR;AAgBI;EACI,kBAAA;EACA,2BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdR;;AAmBA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAhBJ;AAkBI;EACI,sBAAA;AAhBR;;AAoBA;EACI,yBAAA;AAjBJ","sourcesContent":[".navBarComponent {\n    display: flex;\n    padding: 0 2rem;\n    width: 100%;\n    height: 70px;\n    justify-content: space-between;\n    background-color: white;\n    border-bottom: 1px solid #e8e9e9;\n\n    .logoContainer {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        \n    }\n\n    .divider {\n        position: relative;\n        margin: 0 2rem;\n        height: 32px;\n        width: 1px;\n        border-radius: 0.5px;\n        background: #000000;\n        opacity: 0.1;\n    }\n\n    .businessSelectLogoContainer {\n        display: inline-block;\n        position: relative;\n        margin-left: 10px;\n        bottom: 3px;\n    }\n\n    .businessSelectButton {\n        .buttonText {\n            color: #075453;\n        }\n    }\n    .businessSelectButton:hover {\n        .buttonText {\n            color: #097674;\n        }\n    }\n\n    .flexedRightContainer {\n        display: flex;\n        align-items: center;\n    }\n\n    .profileImageContainer {\n        position: relative;\n        display: flex;\n        margin-left: 20px;\n        width: 32px;\n        height: 32px;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        strong {\n            color: white;\n            font-size: 12px;\n        }\n    }\n\n    .questionMarkContainer {\n        position: relative;\n        margin-left: 20px;\n        width: 32px;\n        height: 32px;\n        border-radius: 16px;\n        text-align: center;\n        cursor: pointer;\n    }\n\n    .shopsolPaymentButtonContainer {\n        position: relative;\n        margin-left: 20px;\n        width: 111px;\n        height: 36px;\n        color: rgb(0, 0, 0);\n        text-align: center !important;\n        font-size: 14px;\n        padding-top: 5px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        color: #333333;\n        border-radius: 50px;\n        border: 2px solid #333333;\n        cursor: pointer;\n    }\n\n    .shopsolPaymentButtonText {\n        position: relative;\n        top: 1.5px;\n        cursor: pointer;\n    }\n\n    .daysLeftContainer {\n        position: relative;\n        font-family: 'Noto Sans KR';\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        text-align: right;\n        color: #bd1823;\n    }\n\n}\n\n.navBarMenuItem {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    cursor:pointer;\n    color: #333333;\n    padding: 10px 0;\n    \n    :hover {\n        background-color: #ddd;\n    }\n}\n\n.navBarMenuItem:hover {\n    background-color: #f9f9f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
